"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get clearPrefix () {
        return clearPrefix;
    },
    get findWithIdentifier () {
        return findWithIdentifier;
    },
    get generateBaseIdMap () {
        return generateBaseIdMap;
    },
    get generateUniqueName () {
        return generateUniqueName;
    },
    get getEntityIdentifier () {
        return getEntityIdentifier;
    },
    get getParentIdentifier () {
        return getParentIdentifier;
    },
    get reverseGet () {
        return reverseGet;
    },
    get withoutId () {
        return withoutId;
    },
    get withoutNull () {
        return withoutNull;
    }
});
const _models = require("~/models");
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
async function generateBaseIdMap(context, source, idMap) {
    idMap.set(source.base_id, source.base_id);
    idMap.set(source.id, `${source.base_id}::${source.id}`);
    const models = await source.getModels(context);
    for (const md of models){
        idMap.set(md.id, `${source.base_id}::${source.id}::${md.id}`);
        await md.getColumns(context);
        for (const column of md.columns){
            idMap.set(column.id, `${idMap.get(md.id)}::${column.id}`);
        }
        const hooks = await _models.Hook.list(context, {
            fk_model_id: md.id
        });
        for (const hook of hooks){
            idMap.set(hook.id, `${idMap.get(md.id)}::${hook.id}`);
        }
    }
    return models;
}
function clearPrefix(text, prefix) {
    if (!prefix || prefix.length === 0) return text;
    return text.replace(new RegExp(`^${prefix}_?`), '');
}
function withoutNull(obj) {
    const newObj = {};
    let found = false;
    for (const [key, value] of Object.entries(obj)){
        if (value !== null) {
            newObj[key] = value;
            found = true;
        }
    }
    if (!found) return null;
    return newObj;
}
function reverseGet(map, vl) {
    for (const [key, value] of map.entries()){
        if (vl === value) {
            return key;
        }
    }
    return undefined;
}
function withoutId(obj) {
    const { id } = obj, rest = _object_without_properties_loose(obj, [
        "id"
    ]);
    return rest;
}
function getParentIdentifier(id) {
    const arr = id.split('::');
    arr.pop();
    return arr.join('::');
}
function getEntityIdentifier(id) {
    const arr = id.split('::');
    return arr.pop();
}
function findWithIdentifier(map, id) {
    for (const key of map.keys()){
        if (getEntityIdentifier(key) === id) {
            return map.get(key);
        }
    }
    return undefined;
}
function generateUniqueName(name, names) {
    // if name is unique, return it
    if (!names.includes(name)) return name;
    // if name is not unique, add a number suffix
    let newName = name;
    let i = 1;
    while(names.includes(newName)){
        newName = `${name}_${i}`;
        i++;
    }
    return newName;
}
